import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import { HomePage } from "@/pages/HomePage";
import { SearchPage } from "@/pages/SearchPage";
import { MovieDetailPage } from "@/pages/MovieDetailPage";
import { TvDetailPage } from "@/pages/TvDetailPage";
import { MoviesPage } from "@/pages/MoviesPage";
import { SeriesPage } from "@/pages/SeriesPage";
import { StatsPage } from "@/pages/StatsPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { LoginPage, RegisterPage } from "@/pages/AuthPages";
import { DiscoverPage } from "@/pages/DiscoverPage";
import { PersonPage } from "@/pages/PersonPage";

const normalizeBasename = (value) => {
  if (!value) return "";
  if (value === ".") return "";
  return value;
};

const AppRoutes = () => {
  const location = useLocation();
  const isAuthPage = ['/login', '/register'].includes(location.pathname);
  const isDetailPage = location.pathname.startsWith('/movie/') || 
                       location.pathname.startsWith('/tv/') || 
                       location.pathname.startsWith('/person/');

  // Auth pages without layout
  if (isAuthPage) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
      </Routes>
    );
  }

  // Detail pages with minimal layout (no sidebar visible on hero)
  if (isDetailPage) {
    return (
      <Layout>
        <Routes>
          <Route path="/movie/:id" element={<MovieDetailPage />} />
          <Route path="/tv/:id" element={<TvDetailPage />} />
          <Route path="/person/:id" element={<PersonPage />} />
        </Routes>
      </Layout>
    );
  }

  // Main app with full layout
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/discover" element={<DiscoverPage />} />
        <Route path="/discover/:type" element={<DiscoverPage />} />
        <Route path="/movies" element={<MoviesPage />} />
        <Route path="/series" element={<SeriesPage />} />
        <Route path="/stats" element={<StatsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/movie/:id" element={<MovieDetailPage />} />
        <Route path="/tv/:id" element={<TvDetailPage />} />
        <Route path="/person/:id" element={<PersonPage />} />
      </Routes>
    </Layout>
  );
};

function App() {
  return (
    <BrowserRouter basename={normalizeBasename(process.env.REACT_APP_BASENAME || process.env.PUBLIC_URL)}>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
